import moment from 'moment';

// Import Actions
import { subscribeToChannel, INIT_SOCKET, SEND_SOCKET, RECEIVE_SOCKET, SET_REDIRECT, SET_MOUNTED, UPDATE_TABLE, SET_SSR_MODE, REDIRECT, SET_REFERRAL, INIT_PERSISTED_DATA } from './AppActions';
import { LOGIN_USER, LOGOUT_USER } from '../User/UserActions';
import { getPersistedData, persistData } from '../../util/persistor';

// Initial State
export const initialState = {
    socket: null,
    isSSR: false,
    redirect: '',
    redirectIndex: 0,
    isMounted: false,
    referral: null,
	referralDate: null,
    tables: [
        // {
        //     id: 'users-list',
        //     activePage: 3,
        //     pageSize: null,
        //     searchFilters: [
        //         {
        //             property: 'name',
        //             value: 'test'
        //         }
        //     ],
        //     searchText: 'ma recherche'
        // }
    ],
};

const AppReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_REDIRECT:
            return {
                ...state,
                redirect: action.redirect,
            };

        case REDIRECT:
            return {
                ...state,
                redirect: state.redirect ? (action.replaceIfSet && action.redirect ? action.redirect : state.redirect) : (action.redirect || ''),
                redirectIndex: state.redirectIndex + 1,
            };

        case INIT_SOCKET:
            return {
                ...state,
                socket: action.socket,
            };

        case SEND_SOCKET:
            console.log('SEND_SOCKET', action.data);
            state.socket && state.socket.emit(action.data.type, action.data.data);
            return state;

        case RECEIVE_SOCKET:
            console.log('RECEIVE_SOCKET', action.data);
            return state;

        case SET_MOUNTED:
            return {
                ...state,
                isMounted: true,
            };

        case UPDATE_TABLE:
            return {
                ...state,
                tables: [
                    ...state.tables.filter(table => table.id !== action.tableId),
                    {
                        id: action.tableId,
                        ...action.tableData,
                    },
                ],
            };

        // case LOGIN_USER:
        // case LOGOUT_USER:
        //     return {
        //         ...state,
        //         isMounted: true,
        //     };

        case SET_SSR_MODE:
            return {
                ...state,
                isSSR: action.isSSR,
            };

		case SET_REFERRAL: {
			const newState = {
				...state,
				referral: action.referral,
				referralDate: moment.utc().format(),
			};
			// Persist only referral data
			persistData('app', getDataToPersist(newState));
			return newState;
		}

        case INIT_PERSISTED_DATA: {
			const storedState = getPersistedData('app', null);
			if(storedState) {
				return {
					...state,
					...storedState,
				};
			}
			persistData('app', getDataToPersist(state));
            return state;
		}

        default:
            return state;
    }
};

function getDataToPersist(state) {
	const { referral, referralDate, ...otherData } = state;
	return {
		referral,
		referralDate,
	};
}

// Export Reducer
export default AppReducer;
